export default __webpack_public_path__ + "static/media/Holicef-1-g-IM-eng.bedec5fb.jpg";